import CheckBox from '@/components/basicComponents/checkbox';
import Input from '@/components/basicComponents/input';
import { TableColumns } from '@/components/table/types';
import { themeVar } from '@/styles/theme';
import { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';
import { handleSelectAll, selectColumns } from '../utils';
import { SelectColumnsWrapper } from './selectedColumnsList';

interface ColumnsDisplayedListProps {
  newColumns: TableColumns[];
  setNewColumns: Dispatch<SetStateAction<TableColumns[]>>;
}

export const ColumnsDisplayed = ({ newColumns, setNewColumns }: ColumnsDisplayedListProps) => {
  const [search, setSearch] = useState('');

  return (
    <SelectColumnsWrapper isShadow>
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search Columns" width="100%" size="sm" withSearchIcon />
      <SelectAction>
        <SelectAll isSelectAll onClick={() => handleSelectAll({ isHidden: false, newColumns, setNewColumns })}>
          Select All
        </SelectAll>
        <>|</>
        <SelectAll onClick={() => handleSelectAll({ isHidden: true, newColumns, setNewColumns })}>Deselect All</SelectAll>
      </SelectAction>
      <ChooseColumn>
        {[...newColumns]
          .filter((item) => !item.isFixed && item.title.toLowerCase().includes(search.toLowerCase()))
          .sort((a, b) => a.order - b.order)
          .map((el, index) => (
            <CustomPrimaryFilterItem id="input" key={el.title + index} onClick={() => selectColumns(el.keySort, newColumns, setNewColumns)}>
              <CheckBox id="input" isActive={!el.isHidden} /> {el.title}
            </CustomPrimaryFilterItem>
          ))}
      </ChooseColumn>
    </SelectColumnsWrapper>
  );
};

const SelectAction = styled.div`
  display: flex;
  gap: 3px;
  font-weight: 600;
  font-size: 13px;
  color: ${themeVar('border.base')};
`;

const SelectAll = styled.div<{ isSelectAll?: boolean }>`
  color: ${({ isSelectAll }) => (isSelectAll ? themeVar('font.action') : themeVar('font.disabled'))};
  cursor: pointer;
`;

const ChooseColumn = styled.div``;

const CustomPrimaryFilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  font-weight: 400;
  font-size: 16px;
  color: ${themeVar('font.base')};
  line-height: 18px;
  text-align: left;
  width: 100%;
  cursor: pointer;
  padding: 6.5px 8px;
`;
